const styles = (theme) => ({
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  avatar: {
    color: theme.palette.custom.accounts,
    backgroundColor: theme.palette.background.lighter,
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
  },
  balanceMobile: {
    padding: `${theme.spacing.unit * 2}px 0`,
  },
  paymentReferenceContainer: {
    marginTop: theme.spacing.unit * 2,
  },
  paymentReference: {
    fontSize: '0.875rem',
    marginTop: theme.spacing.unit * 2,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
  },
  cardTitleLarge: {
    '&&': {
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.375rem',
      },
      [theme.breakpoints.up('md')]: {
        paddingBottom: theme.spacing.unit * 3,
      },
    },
  },
  actionContainer: {
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 2,
      borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    },
  },
  actionLabel: {
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.1875rem',
    },
  },
  root: {
    '& .GridItemLeft': {
      [theme.breakpoints.down('xs')]: {
        flexGrow: '1',
        maxWidth: '100%',
        flexBasis: '100%',
      },
    },
    '& .GridItemRight': {
      [theme.breakpoints.down('xs')]: {
        flexGrow: '1',
        maxWidth: '100%',
        flexBasis: '100%',
        textAlign: 'left',
        '& button': {
          padding: 0,
        },
      },
    },
  },
});

export default styles;
